import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule, FlexModule } from '@ngbracket/ngx-layout';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { GroupsStoreModule } from '@libs/src/groups/groups-store/groups-store.module';
import { ListValuesDialogModule } from '@libs/src/list-values-dialog/list-values-dialog.module';
import { ZendeskLinkModule } from '@libs/src/zendesk-link/zendesk-link.module';
import { GroupCustomPrivateSegmentsDrawerModule } from '@main-client/src/app/group-custom-private-segments/group-custom-private-segments-drawer/group-custom-private-segments-drawer.module';
import { AddSegmentOptionsDrawerModule } from '@main-client/src/app/group-custom-segments-settings/add-segment-options-drawer/add-segment-options-drawer.module';
import { GroupCustomSegmentsDrawerModule } from '@main-client/src/app/group-custom-segments-settings/group-custom-segments-drawer/group-custom-segments-drawer.module';
import { PopulateSegmentValuesDrawerModule } from '@main-client/src/app/members/automated-user-management/populate-segment-values-drawer/populate-segment-values-drawer.module';

import { AttributeMappingDrawerService } from './attribute-mapping-drawer.service';
import { ListValuesDialogService } from '@libs/src/list-values-dialog/list-values-dialog.service';
import { GroupCustomSegmentsService } from '@main-client/src/app/group-custom-segments-settings/group-custom-segments.service';
import { HubConfigRolesDrawerService } from '@main-client/src/app/hub-configuration/hub-config-roles/hub-config-roles-drawer/hub-config-roles-drawer.service';
import { PopulateSegmentValuesDrawerService } from '@main-client/src/app/members/automated-user-management/populate-segment-values-drawer/populate-segment-values-drawer.service';

import { AttributeMappingDrawerComponent } from './attribute-mapping-drawer.component';

@NgModule({
  declarations: [AttributeMappingDrawerComponent],
  exports: [AttributeMappingDrawerComponent],
  imports: [
    AddSegmentOptionsDrawerModule,
    CommonModule,
    FlexLayoutModule,
    FlexModule,
    FormsModule,
    GroupCustomPrivateSegmentsDrawerModule,
    GroupCustomSegmentsDrawerModule,
    GroupsStoreModule,
    ListValuesDialogModule,
    MatButtonModule,
    MatIconModule,
    NzDrawerModule,
    NzDropDownModule,
    NzSelectModule,
    NzTableModule,
    NzToolTipModule,
    PopulateSegmentValuesDrawerModule,
    ReactiveFormsModule,
    ZendeskLinkModule,
  ],
  providers: [
    AttributeMappingDrawerService,
    GroupCustomSegmentsService,
    HubConfigRolesDrawerService,
    ListValuesDialogService,
    PopulateSegmentValuesDrawerService,
  ],
})
export class AttributeMappingDrawerModule {}
